import { ReactFlowProvider } from 'reactflow';
import { RolesHierarchy } from './react-flow';
export default function Mainpage() {
  return (
    <ReactFlowProvider>
      <RolesHierarchy />
    </ReactFlowProvider>
  );
}
